import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetAllPR_InformationAppByPR_ReportsStagesGuid = createAsyncThunk(
  "InformationApp/GetAllPR_InformationAppByPR_ReportsStagesGuid",
  async (reportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationApp/GetAllPR_InformationAppByPR_ReportsStagesGuid",
        reportsStagesGuid
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdatePR_InformationApp = createAsyncThunk(
  "InformationApp/UpdatePR_InformationApp",
  async (update, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationApp/UpdatePR_InformationApp",
        {
          pR_InformationAppId: update.pR_InformationAppId,
          pR_InformationAppNameId: update.pR_InformationAppNameId,
          ios: update.ios,
          andriod: update.andriod,
          total: update.total,
          pR_ReportsStagesGuid: update.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteInformationApp = createAsyncThunk(
  "GetSpecificRowNoteInformationAppp/GetSpecificRowNoteInformationApp",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
// console.log(data,"hjjjjjjj");

      // return data.filter((item) => item.incrementNumber - 1 === 1);
        return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const InformationApp = createSlice({
  name: "InformationApp",
  initialState: {
    InformationAppInfo: [],
    loadingInformationAppInfo: false,
    errorInformationAppInfo: null,
    //----------------------- update -------------------------------------
    UpdateInformationAppInfo: [],
    loadingUpdateInformationAppInfo: false,
    errorUpdateInformationAppInfo: null,
    //----------------------- get specific row note ---------------------------
    OneSpecificRowNoteInformationApp: {},
    loadingOneSpecificRowNoteInformationApp: false,
    errorOneSpecificRowNoteInformationApp: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        GetAllPR_InformationAppByPR_ReportsStagesGuid.pending,
        (state, action) => {
          state.loadingInformationAppInfo = true;
          state.InformationAppInfo = action.payload;
          state.errorInformationAppInfo = null;
        }
      )
      .addCase(
        GetAllPR_InformationAppByPR_ReportsStagesGuid.fulfilled,
        (state, action) => {
          state.loadingInformationAppInfo = false;
          state.InformationAppInfo = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetAllPR_InformationAppByPR_ReportsStagesGuid.rejected,
        (state, action) => {
          state.loadingInformationAppInfo = false;
          state.InformationAppInfo = action.payload;
        }
      )
      //-------------------------------------- update ---------------------------------------
      .addCase(UpdatePR_InformationApp.pending, (state, action) => {
        state.loadingUpdateInformationAppInfo = true;
        state.UpdateInformationAppInfo = action.payload;
        state.errorUpdateInformationAppInfo = null;
      })
      .addCase(UpdatePR_InformationApp.fulfilled, (state, action) => {
        state.loadingUpdateInformationAppInfo = false;
        state.UpdateInformationAppInfo = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdatePR_InformationApp.rejected, (state, action) => {
        state.loadingUpdateInformationAppInfo = false;
        state.UpdateInformationAppInfo = action.payload;
      })
      //-------------------------------------- get specific row note ---------------------------------------
      .addCase(GetSpecificRowNoteInformationApp.pending, (state, action) => {
        state.loadingOneSpecificRowNoteInformationApp = true;
        state.OneSpecificRowNoteInformationApp = action.payload;
        state.errorOneSpecificRowNoteInformationApp = null;
      })
      .addCase(GetSpecificRowNoteInformationApp.fulfilled, (state, action) => {
        state.loadingOneSpecificRowNoteInformationApp = false;
        state.OneSpecificRowNoteInformationApp = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificRowNoteInformationApp.rejected, (state, action) => {
        state.loadingOneSpecificRowNoteInformationApp = false;
        state.errorOneSpecificRowNoteInformationApp = action.payload;
      });
  },
});

export default InformationApp.reducer;
